import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { AttendeeNote } from "../../types/Types";

function normalizeAttendeeNote(raw: AttendeeNote & Record<string, unknown>): AttendeeNote {
  const photo =
    (raw.attendeePhoto as string | null | undefined) ||
    (raw.AttendeePhoto as string | null | undefined) ||
    null;
  return {
    ...raw,
    attendeePhoto: typeof photo === "string" && photo.trim() ? photo.trim() : null,
  };
}

export function useGetMyAttendeeNotes(enabled = true) {
  return useQuery({
    enabled,
    queryKey: ["attendeeNotes", "mine"],
    queryFn: async () => {
      const response = await axiosInstance.get<AttendeeNote[]>(
        getAPIURL("/AttendeeNote/Mine")
      );
      const rows = response.data ?? [];
      return rows.map((n) =>
        normalizeAttendeeNote(n as AttendeeNote & Record<string, unknown>)
      );
    },
  });
}
